exports = module.exports = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1hTFXWhu0r3m6GapdwSvDy{width:20px!important;height:23px!important}html[dir] ._1hTFXWhu0r3m6GapdwSvDy{background-size:28px 19px;background-repeat:no-repeat;background-position:1px 1px!important}._1QNmB2HMr9Vd5igxs7mLP8{fill:\"[theme:neutralPrimary, default:#323130]\";width:19px!important;height:22px!important}", ""]);
// Exports
exports.locals = {
	"teamSnapIconSpriteStyle": "_1hTFXWhu0r3m6GapdwSvDy",
	"teamSnapIcon": "_1QNmB2HMr9Vd5igxs7mLP8"
};